import successSound from '../assets/sounds/success.mp3'
import choiceSound from '../assets/sounds/choice2.mp3'
import cardFlipSound from '../assets/sounds/card-flip.mp3'
import dealtCardSound from '../assets/sounds/dealt-card.mp3'
import incorrectSound from '../assets/sounds/incorrect.mp3'
import correctSound from '../assets/sounds/correct.mp3'
import trophySound from '../assets/sounds/trophy-sound.mp3'
import badgeSound from '../assets/sounds/badge.mp3'
import pointSound from '../assets/sounds/point.mp3'
import hangmanCorrectSound from '../assets/sounds/hangman-correct.mp3'
import hangmanCorrectWord from '../assets/sounds/hangman-word.mp3'
import hangmanOverSound from '../assets/sounds/hangman-over.mp3'
import connect4ChipSound from '../assets/sounds/connect4-chip.mp3'
import winnerSound from '../assets/sounds/winner.mp3'
import heartSound from '../assets/sounds/heart.mp3'
import decreaseSound from '../assets/sounds/decrease.mp3'
import bombSound from '../assets/sounds/bomb.mp3'
import diamondSound from '../assets/sounds/diamond.mp3'
import handTakeSound from '../assets/sounds/hand-take.mp3'
import shieldSound from '../assets/sounds/shield.mp3'
import doubleSound from '../assets/sounds/double.mp3'
import lightningSound from '../assets/sounds/lightning.mp3'
import shieldBreakSound from '../assets/sounds/shield-break.mp3'
import drumrollSound from '../assets/sounds/drumroll.mp3'
import wheelSpinSound from '../assets/sounds/wheel-spin.mp3'
import westernSound from '../assets/sounds/western.mp3'
import quizMusic from '../assets/sounds/quiz-music.mp3'
import revealSound from '../assets/sounds/choice2.mp3'
import eraseSound from '../assets/sounds/erase.mp3'
import questionFinishedSound from '../assets/sounds/question-finished.mp3'
import playerJoinedSound from '../assets/sounds/player-joined.mp3'
import countdownSound from '../assets/sounds/countdown.mp3'

export const SOUND_FILES = {
  success: successSound,
  choice: choiceSound,
  cardFlip: cardFlipSound,
  dealtCard: dealtCardSound,
  incorrect: incorrectSound,
  correct: correctSound,
  trophy: trophySound,
  badge: badgeSound,
  point: pointSound,
  coin: pointSound,
  hangmanCorrect: hangmanCorrectSound,
  hangmanCorrectWord: hangmanCorrectWord,
  hangmanOver: hangmanOverSound,
  connect4Chip: connect4ChipSound,
  winner: winnerSound,
  heart: heartSound,
  decrease: decreaseSound,
  bomb: bombSound,
  diamond: diamondSound,
  handTake: handTakeSound,
  shield: shieldSound,
  double: doubleSound,
  lightning: lightningSound,
  shieldBreak: shieldBreakSound,
  drumroll: drumrollSound,
  wheelSpin: wheelSpinSound,
  western: westernSound,
  quizMusic: quizMusic,
  reveal: revealSound,
  erase: eraseSound,
  questionFinished: questionFinishedSound,
  playerJoined: playerJoinedSound,
  countdown: countdownSound
} as const

export type SoundKey = keyof typeof SOUND_FILES